import React, { useState } from "react";
import "./Gallery.css";
import ani2 from "../../assets/ani2.jpg"
import Bread from "../../assets/Bread.jpg"
import clothe1 from "../../assets/clothe1.jpg"
import crop2 from "../../assets/crop2.jpg"
import shoe2 from "../../assets/shoe2.jpg"
import water1 from "../../assets/water1.jpg"
import wood1 from "../../assets/wood1.jpg"
// Array of image URLs (update paths if necessary)
const images = [
  {id:1,image:ani2},
  {id:2,image:Bread},
  {id:3,image:clothe1},
  {id:4,image:crop2},
  {id:5,image:shoe2},
  {id:6,image:water1},
  {id:7,image:wood1},

];

const Gallery = () => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Open preview modal and set current image index
  const openPreview = (index) => {
    setCurrentIndex(index);
    setIsPreviewOpen(true);
  };

  // Close preview modal
  const closePreview = () => setIsPreviewOpen(false);

  // Show next image
  const showNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  // Show previous image
  const showPrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="gallery-container">
      {/* <h2>Geega Resources Gallery</h2> */}
      <div className="gallery-grid">
        {images.map((img, index) => (
          <img
            key={index}
            src={img.image}
            alt={`Gallery item ${index + 1}`}
            onClick={() => openPreview(index)}
            className="gallery-thumbnail"
          />
        ))}
      </div>

      {/* Preview Modal */}
      {isPreviewOpen && (
        <div className="preview-modal">
          <span className="close-button" onClick={closePreview}>&times;</span>
          <img
            src={images[currentIndex].image}
            alt={`Gallery item ${currentIndex + 1}`}
            className="preview-image"
          />
          <button className="prev-button" onClick={showPrevious}>
            &larr;
          </button>
          <button className="next-button" onClick={showNext}>
            &rarr;
          </button>
        </div>
      )}
    </div>
  );
};

export default Gallery;
